(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["se-complete-setup"] && !Shopify.designMode) return;
  try {
    
  /* Arrow buttons for the "Complete your party setup" carousel.

     Progressive enhancement only. The track is a native scroll container, so
     swipe, keyboard and screen-reader scrolling already work without this. The
     carousel NEVER autoplays: nothing here moves the track on a timer. */
  (function () {
    function init(section) {
      var track = section.querySelector('[data-cs-track]');
      var nav = section.querySelector('[data-cs-nav]');
      if (!track || !nav) return;

      var prev = nav.querySelector('[data-cs-prev]');
      var next = nav.querySelector('[data-cs-next]');

      function overflows() {
        return track.scrollWidth - track.clientWidth > 4;
      }

      function step() {
        var item = track.querySelector('.complete-setup__item');
        if (!item) return track.clientWidth;
        var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
        return item.getBoundingClientRect().width + gap;
      }

      function sync() {
        nav.hidden = !overflows();
        if (nav.hidden) return;
        var max = track.scrollWidth - track.clientWidth;
        prev.disabled = track.scrollLeft <= 2;
        next.disabled = track.scrollLeft >= max - 2;
      }

      function move(dir) {
        var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        track.scrollBy({ left: dir * step(), behavior: reduce ? 'auto' : 'smooth' });
      }

      prev.addEventListener('click', function () {
        move(-1);
      });
      next.addEventListener('click', function () {
        move(1);
      });

      /* Move a whole card per key press. Native arrow-key scrolling nudges by a
         few pixels, which scroll-snap then drags back to where it started — the
         track reads as stuck. Home/End jump to the ends. */
      track.addEventListener('keydown', function (event) {
        var handled = true;
        switch (event.key) {
          case 'ArrowRight':
            move(1);
            break;
          case 'ArrowLeft':
            move(-1);
            break;
          case 'Home':
            track.scrollTo({ left: 0, behavior: 'smooth' });
            break;
          case 'End':
            track.scrollTo({ left: track.scrollWidth, behavior: 'smooth' });
            break;
          default:
            handled = false;
        }
        if (handled) event.preventDefault();
      });

      track.addEventListener('scroll', sync, { passive: true });
      window.addEventListener('resize', sync);
      /* Card images load lazily, so the track's width changes after first paint
         without ever firing a window resize. */
      if (window.ResizeObserver) {
        new ResizeObserver(sync).observe(track);
      }
      sync();
    }

    function boot() {
      document.querySelectorAll('.complete-setup').forEach(init);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }
    /* Theme editor re-renders a section without a full page load. */
    document.addEventListener('shopify:section:load', function (event) {
      event.target.querySelectorAll('.complete-setup').forEach(init);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["se-price-estimator"] && !Shopify.designMode) return;
  try {
    
  /* Price my party — pure calculator. Reads prices and stock caps rendered by
     Liquid, keeps a running total, and on "Book this" sends the customer to the
     headset page with boxes/channels preselected and the chosen extras stored
     for the checklist. It never calls the cart. */
  (function () {
    'use strict';
    var panel = document.querySelector('[data-se-estimator]');
    if (!panel) return;
    var format = panel.getAttribute('data-money-format') || '$'+'{'+'{amount}}';
    var bookUrl = panel.getAttribute('data-book-url') || '/products/silent-disco-bundle';
    var rows = Array.prototype.slice.call(panel.querySelectorAll('[data-se-pe-row]'));
    var totalEl = panel.querySelector('[data-se-pe-total]');
    var noteEl = panel.querySelector('[data-se-pe-note]');
    var bookBtn = panel.querySelector('[data-se-pe-book]');
    var dateEl = panel.querySelector('[data-se-pe-date]');
    var perBoxMatch = (noteEl && noteEl.textContent.match(/\((\d+) headsets\)/)) || null;
    var perBox = perBoxMatch ? parseInt(perBoxMatch[1], 10) : 0;

    function money(cents) {
      var units = cents / 100;
      var parts = units.toFixed(2).split('.');
      var grouped = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      var noDec = Math.round(units).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      return format
        .replace('{'+'{amount_with_comma_separator}}', grouped.replace(/,/g, '.') + ',' + parts[1])
        .replace('{'+'{amount_no_decimals_with_comma_separator}}', noDec.replace(/,/g, '.'))
        .replace('{'+'{amount_no_decimals}}', noDec)
        .replace('{'+'{amount}}', grouped + '.' + parts[1]);
    }
    function prettyDate(iso) {
      var p = iso.split('-');
      var d = new Date(parseInt(p[0], 10), parseInt(p[1], 10) - 1, parseInt(p[2], 10));
      return d.toLocaleDateString('en-AU', { weekday: 'short', day: 'numeric', month: 'short' });
    }
    function clamp(input) {
      var min = parseInt(input.min, 10) || 0, max = parseInt(input.max, 10) || 99;
      var n = parseInt(input.value, 10);
      if (!isFinite(n)) n = min;
      n = Math.max(min, Math.min(max, n));
      input.value = n;
      return n;
    }
    function state() {
      var s = { boxes: 1, tx: 1, extras: [], total: 0 };
      rows.forEach(function (row) {
        var kindPre = row.getAttribute('data-kind');
        var inputPre = row.querySelector('[data-se-pe-input]');
        if (kindPre === 'tx') {
          /* A transmitter is only required with headsets. No headsets: none. */
          if (s.boxes === 0) { inputPre.min = 0; inputPre.value = 0; }
          else { inputPre.min = 1; if (parseInt(inputPre.value, 10) < 1) inputPre.value = 1; }
          row.classList.toggle('se-estimator__row--off', s.boxes === 0);
        }
        if (row.getAttribute('data-cap-to') === 'tx') {
          /* One microphone per transmitter: it plugs into a transmitter and
             talks over that channel, so there can never be more mics than
             channels. */
          inputPre.max = s.tx;
          if (parseInt(inputPre.value, 10) > s.tx) inputPre.value = s.tx;
          row.classList.toggle('se-estimator__row--off', s.tx === 0);
        }
        var n = clamp(inputPre);
        var price = parseInt(row.getAttribute('data-price'), 10) || 0;
        var kind = row.getAttribute('data-kind');
        var line = row.querySelector('[data-se-pe-line]');
        var unit = row.querySelector('[data-se-pe-unit]');
        if (kind === 'boxes') { s.boxes = n; if (unit) unit.textContent = n === 1 ? 'box' : 'boxes'; }
        else if (kind === 'tx') { s.tx = n; if (unit) unit.textContent = n === 1 ? 'channel' : 'channels'; }
        else if (n > 0) {
          s.extras.push({ handle: row.getAttribute('data-handle'), title: row.getAttribute('data-title'), url: row.getAttribute('data-url'), price: price, qty: n });
        }
        if (line) line.textContent = n > 0 ? money(n * price) : '—';
        s.total += n * price;
        var minus = row.querySelector('[data-se-pe-minus]'), plus = row.querySelector('[data-se-pe-plus]');
        var input = row.querySelector('[data-se-pe-input]');
        if (minus) minus.disabled = n <= (parseInt(input.min, 10) || 0);
        if (plus) plus.disabled = n >= (parseInt(input.max, 10) || 99);
      });
      return s;
    }
    function render() {
      var s = state();
      if (totalEl) totalEl.textContent = money(s.total);
      var group = panel.querySelector('[data-se-pe-group]');
      if (group) {
        var inGroup = s.extras.filter(function (e) { return !!group.querySelector('[data-se-pe-row][data-handle="' + e.handle + '"]'); });
        var chosen = group.querySelector('[data-se-pe-group-chosen]');
        var sub = inGroup.reduce(function (t, e) { return t + e.qty * e.price; }, 0);
        if (chosen) chosen.textContent = inGroup.length ? inGroup.reduce(function (t, e) { return t + e.qty; }, 0) + ' chosen \u00b7 ' + money(sub) : 'Lighting, sound, haze and more';
        if (inGroup.length && !group.open && !group.hasAttribute('data-se-pe-user-closed')) group.open = true;
      }
      if (noteEl) {
        var bits = [];
        if (s.boxes > 0) bits.push(s.boxes + (s.boxes === 1 ? ' box' : ' boxes') + (perBox ? ' (' + s.boxes * perBox + ' headsets)' : ''));
        if (s.tx > 0) bits.push(s.tx + (s.tx === 1 ? ' transmitter' : ' transmitters'));
        s.extras.forEach(function (e) { bits.push(e.qty + '× ' + e.title.replace(/\s*\(.*?\)\s*/g, ' ').replace(/\s+—.*$/, '').trim()); });
        noteEl.textContent = bits.length ? bits.join(' + ') + ' · pickup free' : 'Nothing chosen yet';
      }
      if (bookBtn) {
        var label = bookBtn.getAttribute('data-label') || (bookBtn.setAttribute('data-label', bookBtn.textContent), bookBtn.textContent);
        var date = dateEl && /^\d{4}-\d{2}-\d{2}$/.test(dateEl.value) ? dateEl.value : '';
        var extrasQ = (s.extras.length ? '&extras=' + encodeURIComponent(s.extras.map(function (e) { return e.handle + ':' + e.qty; }).join(',')) : '') + (date ? '&date=' + date : '');
        var when = date ? ' for ' + prettyDate(date) : '';
        if (date && (s.boxes > 0 || s.extras.length)) {
          /* Date chosen: the button adds the whole night to the cart (see addNight). */
          bookBtn.setAttribute('href', '#price');
          bookBtn.setAttribute('data-se-pe-add', '1');
          bookBtn.removeAttribute('aria-disabled');
          bookBtn.textContent = label + ' \u2014 ' + money(s.total);
        } else if (s.boxes > 0) {
          bookBtn.removeAttribute('data-se-pe-add');
          /* No date yet: hand off to the headset page, which presets boxes and channels. */
          bookBtn.setAttribute('href', bookUrl + (bookUrl.indexOf('?') >= 0 ? '&' : '?') + 'boxes=' + s.boxes + '&tx=' + s.tx + extrasQ);
          bookBtn.removeAttribute('aria-disabled');
          bookBtn.textContent = label + ' — ' + money(s.total);
        } else if (s.extras.length) {
          bookBtn.removeAttribute('data-se-pe-add');
          /* Lights or sound only, no date: start on the first chosen product's page. */
          var first = s.extras[0];
          bookBtn.setAttribute('href', first.url + (first.url.indexOf('?') >= 0 ? '&' : '?') + 'qty=' + first.qty + extrasQ);
          bookBtn.removeAttribute('aria-disabled');
          bookBtn.textContent = label + ' — ' + money(s.total);
        } else {
          bookBtn.removeAttribute('data-se-pe-add');
          bookBtn.setAttribute('href', '#price');
          bookBtn.setAttribute('aria-disabled', 'true');
          bookBtn.textContent = 'Choose what you need';
        }
        if (!date) bookBtn.textContent = bookBtn.textContent.replace(/^Add my night to cart/, 'Book this for my date');
      }
      try { sessionStorage.setItem('se_party', JSON.stringify({ boxes: s.boxes, tx: s.tx, extras: s.extras, total: s.total, date: date, at: Date.now() })); } catch (e) {}
    }
    /* Item popup: picture, price, short description, link to the full page. */
    var dialog = panel.querySelector('[data-se-pe-dialog]');
    function openInfo(row) {
      if (!dialog) return;
      var img = dialog.querySelector('[data-se-pe-dialog-img]');
      var src = row.getAttribute('data-info-image') || '';
      img.hidden = !src; if (src) { img.src = src; img.alt = row.getAttribute('data-info-title') || ''; }
      dialog.querySelector('[data-se-pe-dialog-title]').textContent = row.getAttribute('data-info-title') || '';
      dialog.querySelector('[data-se-pe-dialog-price]').textContent = (row.getAttribute('data-info-price') || '') + (row.getAttribute('data-kind') === 'extra' ? ' per night' : row.getAttribute('data-kind') === 'boxes' ? ' per box, overnight hire' : ' each');
      dialog.querySelector('[data-se-pe-dialog-desc]').textContent = row.getAttribute('data-info-desc') || '';
      dialog.querySelector('[data-se-pe-dialog-pickup]').textContent = row.getAttribute('data-rosebud') === 'true' ? 'Collected from Mount Eliza, or Rosebud on request (by appointment, confirmed in writing).' : 'Collected from Mount Eliza only.';
      dialog.querySelector('[data-se-pe-dialog-link]').href = row.getAttribute('data-info-url') || '#';
      if (typeof dialog.showModal === 'function') dialog.showModal(); else dialog.setAttribute('open', '');
    }
    /* ---- add the whole night to the cart ----
       One /cart/add.js call per item, in order (headsets, transmitters, extras),
       each with the rental properties FlexCon's own form would send for that
       date: purchase option 1 (rent), start and end date, and the duration id
       FlexCon uses for the product (0 = fixed overnight hire, 1 = a run of
       nights, read from the product's FlexCon config). FlexCon validates every
       line server-side and rejects anything unavailable; a rejected item is
       reported with a link to its page, and the rest stay in the cart. */
    var statusEl = panel.querySelector('[data-se-pe-status]');
    function setStatus(text, isError) {
      if (!statusEl) return;
      statusEl.textContent = '';
      if (!text) { statusEl.hidden = true; return; }
      statusEl.hidden = false;
      statusEl.classList.toggle('se-estimator__status--error', !!isError);
      if (typeof text === 'string') statusEl.textContent = text; else statusEl.appendChild(text);
    }
    function flexProps(row, date) {
      var fixed = row.getAttribute('data-flex-fixed') === 'true';
      return {
        _flex_conversion_purchase_option: '1',
        _flex_conversion_start_date: date,
        _flex_conversion_end_date: date,
        _flex_conversion_duration_id: fixed ? '0' : '1',
        _flex_conversion_deposit: '0'
      };
    }
    function addOne(item) {
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: item.variant, quantity: item.qty, properties: item.props }] })
      }).then(function (r) {
        return r.json().catch(function () { return {}; }).then(function (j) {
          if (r.ok) return { ok: true, item: item };
          return { ok: false, item: item, message: j.description || j.message || ('could not be added (' + r.status + ')') };
        });
      }).catch(function () { return { ok: false, item: item, message: 'could not be added' }; });
    }
    var adding = false;
    function addNight() {
      if (adding) return;
      var s = state();
      var date = dateEl && /^\d{4}-\d{2}-\d{2}$/.test(dateEl.value) ? dateEl.value : '';
      if (!date) { setStatus('Choose your date first.', true); if (dateEl) dateEl.focus(); return; }
      var items = [];
      rows.forEach(function (row) {
        var n = parseInt(row.querySelector('[data-se-pe-input]').value, 10) || 0;
        if (n < 1) return;
        var variant = parseInt(row.getAttribute('data-variant'), 10);
        if (!variant) return;
        items.push({ variant: variant, qty: n, title: row.getAttribute('data-title') || row.getAttribute('data-handle'), url: row.getAttribute('data-url'), props: flexProps(row, date) });
      });
      if (!items.length) { setStatus('Choose what you need first.', true); return; }
      adding = true;
      var original = bookBtn.textContent;
      bookBtn.setAttribute('aria-disabled', 'true');
      bookBtn.textContent = 'Adding to your cart\u2026';
      setStatus('');
      var results = [];
      items.reduce(function (chain, item) {
        return chain.then(function () { return addOne(item).then(function (r) { results.push(r); }); });
      }, Promise.resolve()).then(function () {
        var failed = results.filter(function (r) { return !r.ok; });
        adding = false;
        if (!failed.length) {
          try { sessionStorage.removeItem('se_party'); } catch (e) {}
          bookBtn.textContent = 'Added \u2014 opening your cart\u2026';
          window.location.href = '/cart';
          return;
        }
        bookBtn.removeAttribute('aria-disabled');
        bookBtn.textContent = original;
        var frag = document.createDocumentFragment();
        var added = results.filter(function (r) { return r.ok; });
        var p1 = document.createElement('span');
        p1.textContent = (added.length ? added.length + ' item' + (added.length > 1 ? 's' : '') + ' added to your cart. ' : '') + 'Not available on that date: ';
        frag.appendChild(p1);
        failed.forEach(function (r, i) {
          var a = document.createElement('a');
          a.href = r.item.url + '?qty=' + r.item.qty;
          a.textContent = r.item.title;
          frag.appendChild(a);
          var note = document.createElement('span');
          note.textContent = ' (' + r.message + ')' + (i < failed.length - 1 ? ', ' : '. ');
          frag.appendChild(note);
        });
        var p2 = document.createElement('span');
        p2.textContent = 'Try another date, or open the item to see which dates are free.';
        frag.appendChild(p2);
        setStatus(frag, true);
      });
    }
    var grp = panel.querySelector('[data-se-pe-group]');
    if (grp) grp.addEventListener('toggle', function () { if (!grp.open) grp.setAttribute('data-se-pe-user-closed', '1'); else grp.removeAttribute('data-se-pe-user-closed'); });
    panel.addEventListener('click', function (e) {
      var book = e.target.closest && e.target.closest('[data-se-pe-book]');
      if (book && book.getAttribute('data-se-pe-add') === '1') { e.preventDefault(); addNight(); return; }
      var info = e.target.closest && e.target.closest('[data-se-pe-info]');
      if (info) { openInfo(info.closest('[data-se-pe-row]')); return; }
      if (e.target.closest && e.target.closest('[data-se-pe-dialog-close]')) { dialog.close ? dialog.close() : dialog.removeAttribute('open'); return; }
      if (dialog && e.target === dialog) { dialog.close ? dialog.close() : dialog.removeAttribute('open'); return; }
      var btn = e.target.closest && e.target.closest('[data-se-pe-minus], [data-se-pe-plus]');
      if (!btn) return;
      var input = btn.closest('[data-se-pe-row]').querySelector('[data-se-pe-input]');
      var n = parseInt(input.value, 10) || 0;
      input.value = btn.hasAttribute('data-se-pe-plus') ? n + 1 : n - 1;
      render();
    });
    panel.addEventListener('input', function (e) { if (e.target.matches('[data-se-pe-input], [data-se-pe-date]')) render(); });
    panel.addEventListener('change', function (e) { if (e.target.matches('[data-se-pe-input], [data-se-pe-date]')) render(); });
    try { var saved = JSON.parse(sessionStorage.getItem('se_party') || 'null'); if (saved && saved.date && dateEl && !dateEl.value) dateEl.value = saved.date; } catch (e) {}
    render();
  })();

  } catch(e) { console.error(e); }
})();
})();
